import { FormEvent, useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import type { MenteeBookingRow } from './MenteePortalService';

type Props = {
    show: boolean;
    booking: MenteeBookingRow | null;
    submitting: boolean;
    errorMessage: string | null;
    onClose: () => void;
    onSave: (agenda: string | null) => void;
};

const MenteeSessionsAgendaModal = ({
    show,
    booking,
    submitting,
    errorMessage,
    onClose,
    onSave,
}: Props) => {
    const [agenda, setAgenda] = useState('');

    useEffect(() => {
        if (show && booking) {
            setAgenda(booking.agenda || '');
        }
    }, [show, booking]);

    const handleSubmit = (event: FormEvent) => {
        event.preventDefault();
        const trimmed = agenda.trim();
        onSave(trimmed === '' ? null : trimmed);
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Session agenda</Modal.Title>
            </Modal.Header>
            <form onSubmit={handleSubmit}>
                <Modal.Body>
                    {booking ? (
                        <p className="msess-sub">
                            {booking.bookedDate} · Topic: {booking.topic}
                        </p>
                    ) : null}
                    <div className="msess-field">
                        <label htmlFor="msess-agenda-edit">Agenda</label>
                        <textarea
                            id="msess-agenda-edit"
                            value={agenda}
                            onChange={(event) => setAgenda(event.target.value)}
                            placeholder="What would you like to cover?"
                            rows={4}
                        />
                    </div>
                    {errorMessage ? <p className="msess-error">{errorMessage}</p> : null}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={onClose} disabled={submitting}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary" disabled={submitting || !booking}>
                        {submitting ? 'Saving…' : 'Save agenda'}
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default MenteeSessionsAgendaModal;
